<template>
  <div class="filling-goods-div">
    <div style="padding-top: 5px; font-size: 16px">新建布匹入库</div>
    <div class="filling-goods-head">
      <div class="filling-goods-head-div">
        <div class="search">
          <div style="width: 10%; text-align: left;">货号:</div>
          <input style="width: 90%" v-model="goods_number" @keyup.enter="goSearchFabric()" />
        </div>
        <div class="data-link">
          <div style="width: 20%; text-align: left;">关联单号:</div>
          <div style="width: 80%"></div>
        </div>
        <div class="data-link-header">
          <div class="data-link-g">
            <div style="width: 20%; text-align: left;">库位:</div>
            <div style="width: 80%"></div>
          </div>
          <div class="data-link-b">
            <div style="width: 50%; text-align: left;">供应商型号:</div>
            <!-- <input style="width: 50%"  v-model="supplier_xh" readonly="readonly"/> -->
            <div>{{ supplier_xh }}</div>
          </div>
        </div>
        <div class="data-link-header">
          <div class="data-link-b">
            <div style="width: 20%; text-align: left;">数量:</div>
            <input style="width: 50%" v-model="count" type="number" />
          </div>
          <div class="data-link-b">
            <div style="width: 20%; text-align: left;">缸号:</div>
            <input style="width: 50%" v-model="cylinder_number" />
          </div>
        </div>
        <div class="data-link-header">
          <div class="data-link-b">
            <div style="width: 20%; text-align: left;">门幅:</div>
            <input style="width: 50%" v-model="menfu" type="number" />
          </div>
          <div class="data-link-b">
            <div style="width: 20%; text-align: left;"></div>
            <input style="width: 50%;display: none;" disabled='true' />
          </div>
        </div>
      </div>
    </div>
    <div style="display: flex; padding:0px 5px 10px 5px;align-items: center;justify-content: center;">
      <div style="width: 10%; ">备注:</div>
      <input style="width: 90%;height: 40px;" v-model="reelInfo" />
    </div>

    <span style="color: red" v-if="hostcs">测试服</span>
    <button v-if="hostcs" @click="goSearchFabric()">测试回车</button>
    <div class="filling-goods-bottom" style="display: flex">
      <van-button type="warning" class="bottom-button" @click="go_index()">回首页</van-button>
      <van-button type="info" class="bottom-button"  @click="go_print()">入库打印</van-button>
    </div>
    <van-popup v-model="show" style="height: 70%;width: 80%; overflow: auto;">
      <div class="data-top-header">
        <div class="right-twenty-header">货号</div>
        <div class="right-twenty-header">供应商型号</div>
        <div class="right-twenty-header">供应商</div>
      </div>
      <div class="data-top" v-for="(i, index) in data" :key="index" @click="select(index)">
        <div class="data-order">{{ i.number }}</div>
        <div class="data-order">{{ i.supplier_xh }}</div>
        <div class="data-order">{{ i.supplier_name }}</div>
      </div>
    </van-popup>
    <van-popup v-model="show_print" style="width: 200px;" @close="handlePopupClose">
      <div style="padding:10px;" class="print-only" id="popupPrint">
        <div>
          <div class="list-data">
            <div class="list-data-div">货号:</div>
            <div class="list-data-div">{{ goods_number }}</div>
          </div>
          <div class="list-data">
            <div class="list-data-div">数量:</div>
            <div class="list-data-div">{{ count }}</div>
          </div>
          <div class="list-data">
            <div class="list-data-div-a">供应商名称:</div>
            <div class="list-data-div-a">{{ supplier_name }}</div>
          </div>
          <div class="list-data">
            <div class="list-data-div-a">缸号:</div>
            <div class="list-data-div-a">{{ cylinder_number }}</div>
          </div>
          <div class="list-data">
            <div class="list-data-div-a">门幅:</div>
            <div class="list-data-div-a">{{ menfu }}</div>
          </div>
          <div class="list-data">
            <div class="list-data-div-a">备注:</div>
            <div class="list-data-div-a">{{ reelInfo }}</div>
          </div>
          <div class="list-data">
            <div class="list-data-div-a">时间:</div>
            <div class="list-data-div-a">{{ nowtime }}</div>
          </div>
        </div>
        <Barcode :JsBarcodeData="JsBarcodeConfigData" />
      </div>
      <van-button type="info" @click="dayin()" style="width: 100px; margin : 10px;">打印</van-button>
    </van-popup>
  </div>
</template>

<script>
import $ from "jquery";
import { mapState, mapMutations } from "vuex";
import { Dialog } from "vant";
import { Toast } from "vant";
import axios from 'axios';
import Barcode from '@/components/Barcode';
import html2canvas from 'html2canvas';
export default {
  name: "orderInfo",
  name: "barcode",
  components: {
    Barcode
  },
  data() {
    return {
      hostcs: false,
      more_show: false,
      ray: "扫描中",
      id: "",
      supplier_xh: "",
      supplier_name: "",
      name: "",
      count: "",
      cylinder_number: "",
      count_up: "",
      data: [],
      style: "",
      reeldata: "",
      reelInfo: "",
      goods_number: "",
      fillingGoodsType: true,
      revocationType: true,
      outNumber: "未出库",
      username: "",
      type: "orderInfo",
      show: false,
      show_print: false,
      nowtime: '',
      jieliu: false,
      menfu: '',
      JsBarcodeConfigData: {
        text: '', // 条形码必须是字符串类型，否则会出现后面几位为数字的情况。
        lineColor: "#000000", //二维码颜色
        background: "#fff", //二维码背景色
        //width: this.widthStyleObj, 
        bottomtext: '',
      }
    };
  },
  mounted() {
    //this.tableDomId = 'printCodeTable';
    this.username = JSON.parse(window.localStorage.getItem("userinfo"));
    if (this.$route.query.id !== undefined) {
      this.getIdData(this.$route.query.id);
    }
    var h = document.documentElement.clientHeight || document.body.clientHeight;
    this.style =
      "text-align: left;width: 100%;height: " + h * 0.66 + "px;";
    if (window.location.host.indexOf("cspda") !== -1) {
      this.hostcs = true;
    }
  },
  methods: {
    handlePopupClose(){
        this.reelInfo = '';
        this.count = '';
        this.supplier_xh = '';
    },
    goSearchFabric() {   // 输入货号和型号 查找
      var newApiUrl = window.localStorage.getItem('pdaBASEURL').replace('/api', '');
      //var uar = 'http://localhost:80';
      console.log(newApiUrl)
      if (this.goods_number.length >= 3) {
        this.get(newApiUrl + this.APIOBJ.searchFabric + this.goods_number, { supplier: '', reel: 1 }).then(
          (res) => {
            if (res.data.status == 1) {
              this.data = res.data.data
              this.show = true;
            } else if (res.data.status == 0) {
              Toast(res.data.msg);
            } else {
              Toast('失败');
            }
          }
        );
      } else {
        Toast('货号最少三位数!');
      }
    },
    select(index) {
      this.show = false;
      this.goods_number = this.data[index].number;
      this.supplier_xh = this.data[index].supplier_xh;
      this.supplier_name = this.data[index].supplier_name;
    },
    go_print() {
      if (this.count != "" && this.count >= 0 && this.goods_number != "") {
        this.get("/IncreaseStore", {
          number: this.goods_number,
          reel_detail: this.reelInfo,
          cylinder_number: this.cylinder_number,
          store: this.count,
          supplier_name: this.supplier_name,
          supplier_xh: this.supplier_xh,
          menfu: this.menfu,
        }).then((res) => {
          if (res.data.status == 1) {
            this.nowtime = res.data.data.time
            //this.dayin(res.data.data.reel_id)
            this.$set(this.JsBarcodeConfigData, 'text', res.data.data.reel_id);
            this.$set(this.JsBarcodeConfigData, 'bottomtext', res.data.data.reel_id);
            this.show_print = true;
          } else if (res.data.status == 0) {
            Toast(res.data.msg)
          } else {
            Toast("失败");
          }
        })
      } else {
        Toast('货号和数量不能为空或负!');
      }
    },
    dayin() {
      html2canvas(document.querySelector("#popupPrint")).then((canvas) => {
        //document.body.appendChild(canvas);
        var imageBase64 = canvas.toDataURL();// 将imageData作为参数传递给callAndroid()方法
        var imageBase64 = imageBase64.replace(/^data:image\/\w+;base64,/, '');
        this.reelInfo = '';
        this.count = '';
        this.supplier_xh = '';
        this.callAndroid(imageBase64);
      });
    },
    callAndroid(imageBase64) {
      var BASE64_ENCODED_IMAGE_DATA = imageBase64;
      var imageData = BASE64_ENCODED_IMAGE_DATA;
      //console.log(imageData);
      this.show_print = false;
      Android.receiveImage(imageData);
      alert("printPreview");
    },
    window_dayin() {
      window.print();
    },
    go_index() {
      Dialog.confirm({
        message: "确定要回首页吗？",
      })
        .then(() => {
          this.$router.push("/home");
        })
        .catch(() => {
          // on cancel
        });
    },
    go_scan_url() {
      let url =
        "http://cs.lcyjfz.com/home/scan?id=" + this.$route.query.id || "";
      window.location.href = url;
    },

  },
};

</script>

<style lang="less">
@import "../style/outOrderInfo.less";

.info-data {
  display: flex;
  padding: 0px 10px 10px 10px;
  align-items: center;
  justify-content: center;
}

.bottom-button-x {
  border-radius: 0.5em;
  width: 35%;
}

.data-top {
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  justify-content: space-evenly;
}

.data-top-header {
  width: 100%;
  height: 30px;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  justify-content: space-evenly;
}

.right-twenty-header {
  width: 100%;
  height: 30px;
  text-align: center;
  align-items: center;
  justify-content: center;
  display: flex;
  border-bottom: 0.1px solid #000;
  border-right: 0.1px solid #000;
}

.data-order {
  width: 33%;
  height: 30px;
  text-align: center;
  align-items: center;
  justify-content: center;
  word-wrap: break-word;
  display: flex;
  border-bottom: 0.1px solid #000;
  border-right: 0.1px solid #000;
}

.data-link {
  color: lightgray;
  display: flex;
  padding: 5px 10px 5px 10px;
}

.data-link-g {
  color: lightgray;
  display: flex;
  padding: 5px 10px 5px 10px;
  width: 50%;
}

.data-link-b {
  display: flex;
  padding: 5px 10px 5px 10px;
  width: 50%;
  align-items: center;
}

.data-link-header {
  display: flex;
}

.list-data {
  display: flex;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 10px;
}

.list-data-div {
  padding-right: 3px;
  text-align: left;
  font-size: 18px;
}

.list-data-div-a {
  padding-right: 3px;
  text-align: left;
  font-size: 14px;
}


.search {
  display: flex;
  padding: 5px 10px 5px 10px;
  align-items: center;
  justify-content: center;
}

@media print {
  .print-only {
    display: block; // 仅在打印时显示
  }

  .no-print {
    display: none; // 不在打印时显示
    //margin: 10px;
  }

  @page {
    size: A4;
    /* 设置纸张大小为 A4 */
    margin: 0;
    /* 取消默认页边距 */
  }
}
</style>